var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%","height":"100vh","display":"flex","align-items":"center","justify-content":"center"}},[(_vm.path)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.open}},[_vm._v("打开文件")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }